import * as React from 'react';
import { useTheme } from '../../../theming/useTheme';
import { IframeComponent, IframeProps, IframeThemeProps } from './Iframe';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

const componentConfigurationKey = 'streamable';

const mapThemeToProps = (theme: IframeThemeProps) => ({
  backgroundColor: theme.backgroundColor,
});

export const Streamable: React.FunctionComponent<IframeProps> = props => {
  const themeContext = useTheme(mapThemeToProps, componentConfigurationKey);
  return <ErrorBoundary><IframeComponent {...themeContext} {...props} /></ErrorBoundary>;
};
